import React from "react";
import Popup from "./Popup";
import { Carousel } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faArrowRight, faChevronLeft, faChevronRight } from "@fortawesome/free-solid-svg-icons";

export default function ImagesPopup({ AllImages, isShow, title, closePopup, size, activeIndex, handleActiveIndex, zoomInOut, handleZoomInOut }) {

    const handlePrev = () => {
        const newIndex =
            activeIndex === 0 ? AllImages.length - 1 : activeIndex - 1;
        handleActiveIndex(newIndex);
    };

    const handleNext = () => {
        const newIndex =
            activeIndex === AllImages.length - 1 ? 0 : activeIndex + 1;
        handleActiveIndex(newIndex);
    };

    const modalBody = (
        <>
            {AllImages.length > 1 ?
                <div className="d-flex flex-column">
                    <div className="d-flex justify-content-between align-items-end gap-2 mb-2">
                        <FontAwesomeIcon icon={faArrowLeft} size="xl" className="cursor-pointer" onClick={() => handlePrev()} />
                        <FontAwesomeIcon icon={faArrowRight} size="xl" className="cursor-pointer" onClick={() => handleNext()} />
                    </div>
                    <Carousel activeIndex={activeIndex} onSelect={(selectedIndex) => handleActiveIndex(selectedIndex)} interval={null} controls={false} >
                        {AllImages.map((image, index) => (
                            <Carousel.Item>
                                <div className="overflow-auto">
                                    <img src={image} alt={`displaying-image-${index}`} className="img-fluid" style={{ cursor: zoomInOut ? "zoom-out" : "zoom-in", transform: zoomInOut ? "scale(2)" : "", transformOrigin: "top left", }} onClick={handleZoomInOut} />
                                </div>
                            </Carousel.Item>
                        ))}
                    </Carousel>
                </div>
                : <div className="overflow-auto">
                    <img src={AllImages[0]} alt={`displaying-image-${1}`} className="img-fluid" style={{ cursor: zoomInOut ? "zoom-out" : "zoom-in", transform: zoomInOut ? "scale(2)" : "", transformOrigin: "top left", }} onClick={handleZoomInOut} />
                </div>
            }
        </>
    )

    return (
        <React.Fragment>
            <Popup
                size={size}
                isshow={isShow}
                title={title}
                closePopup={closePopup}
                modalBody={modalBody}
                visibleSaveBtn={false}
            />
        </React.Fragment>
    )
}